import React              from 'react';
import { useTranslation } from 'react-i18next';

import Alert            from 'components/Alert';
import Box              from '@mui/material/Box';
import Checkbox         from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

import PropTypes from 'prop-types';
import Button    from '@mui/material/Button';
import Tooltip   from '@mui/material/Tooltip';
import Grid      from '@mui/material/Grid';


function ReportsForm(props) {

  const { t } = useTranslation();

  const [selectedReportsNames, setSelectedReportsNames] = React.useState(new Set());

  if (!props.availableReports?.length) {
    const alert = {
      msgTranslKey: 'noReportsAvailable',
      type:         'info'
    };
    return (
      <Alert alert={alert}/>
    )
  }

  function isSelected(report) {
    return selectedReportsNames.has(report.name);
  }

  function selectAll(evt) {
    const checked = evt.target.checked;
    if (!checked) {
      setSelectedReportsNames(new Set());
      return;
    }
    const allNames = props.availableReports.map(report => report.name);
    setSelectedReportsNames(new Set(allNames));
  }

  function selectReport(evt, report) {
    const name    = report.name;
    const checked = evt.target.checked;

    setSelectedReportsNames(prevState => {
      const newState = new Set(prevState);

      if (checked)
        newState.add(name);
      else
        newState.delete(name);

      return newState;
    })
  }

  const allCount      = props.availableReports?.length;
  const selectedCount = selectedReportsNames.size;

  const allSelected  = selectedCount === allCount;
  const noneSelected = selectedCount < 1;

  const tooltipTitle = noneSelected ? t('selectAtLeastOne') : '';

  if (!props.availableReports?.length)  //including when it's an empty array
    return null;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>

        <FormControlLabel
          label={t('selectAll')}
          control={
            <Checkbox
              checked={allSelected}
              indeterminate={!allSelected && !noneSelected}
              onChange={selectAll}
            />
          }
        />
        <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
          {props.availableReports.map(report =>
            <FormControlLabel
              label={checkboxLabel(report)}
              key={report.name}
              control={
                <Checkbox
                  checked={isSelected(report)}
                  onChange={evt => selectReport(evt, report)}
                />
              }
            />
          )}
        </Box>
      </Grid>
      <Grid item>
        <Tooltip title={tooltipTitle}>
          <div> {/*//Disabled elements can't hold a ref required by Tooltip*/}
            <Button
              onClick={() => props.onSubmit(Array.from(selectedReportsNames))}
              disabled={noneSelected}
            >
              {t('placeOrder')}
            </Button>
          </div>
        </Tooltip>
      </Grid>
    </Grid>
  );
}

function checkboxLabel(report) {
  const name = report.name;
  const desc = report.desc;
  if (!desc)
    return name;

  return name + ' - ' + desc;
}

ReportsForm.propTypes = {
  availableReports: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      desc: PropTypes.string,
    })
  ).isRequired,
  onSubmit:         PropTypes.func.isRequired
};

export default ReportsForm;